import React, { useState, useEffect, useRef } from "react";
import "./MarcketingSection.scss";

// ── Icons ──────────────────────────────────────────────────────
const IconMail = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
  </svg>
);
const IconCRM = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
  </svg>
);
const IconHotel = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z" />
  </svg>
);
const IconCalendar = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z" />
  </svg>
);

// ══════════════════════════════════════════════
// CARD 1 — Business Email & Calendar
// ══════════════════════════════════════════════
const EmailCard = () => (
  <div className="card__ui">
    <div className="email__topbar">
      <div className="email__topbar-left">
        <div className="email__logo">C</div>
        <span className="email__product">CILPRON Mail</span>
      </div>
      <div className="email__topbar-actions">
        <span className="email__chip email__chip--blue">Inbox</span>
        <span className="email__chip">Calendar</span>
        <span className="email__chip">Drafts</span>
      </div>
    </div>

    <div className="email__layout">
      {/* Sidebar */}
      <div className="email__sidebar">
        <div className="email__compose">+ Compose</div>
        {["Inbox", "Starred", "Sent", "Drafts", "Spam"].map((f, i) => (
          <div key={f} className={`email__folder${i === 0 ? " email__folder--active" : ""}`}>
            <span>{f}</span>
            {i === 0 && <span className="email__unread">4</span>}
          </div>
        ))}
        <div className="email__divider" />
        <div className="email__sidebar-label">UPCOMING</div>
        {[
          { title: "Q3 Review", time: "2:00 PM" },
          { title: "Client Call", time: "4:30 PM" },
        ].map((e) => (
          <div key={e.title} className="email__event">
            <span className="email__event-dot" />
            <div>
              <div className="email__event-title">{e.title}</div>
              <div className="email__event-time">{e.time}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Mail list */}
      <div className="email__list">
        {[
          { from: "Sarah K.", subject: "Q3 Budget Review — Action needed", time: "10:42 AM", unread: true,  ai: "AI: Requires approval by Friday" },
          { from: "Mark T.",  subject: "Partnership proposal attached",    time: "9:15 AM",  unread: true,  ai: "AI: High priority · follow up" },
          { from: "Team",     subject: "Weekly standup notes",             time: "Yesterday",unread: false, ai: null },
          { from: "Finance",  subject: "Invoice #4421 approved",           time: "Monday",   unread: false, ai: null },
        ].map((m) => (
          <div key={m.subject} className={`email__row${m.unread ? " email__row--unread" : ""}`}>
            <div className="email__row-avatar">{m.from[0]}</div>
            <div className="email__row-body">
              <div className="email__row-top">
                <span className="email__row-from">{m.from}</span>
                <span className="email__row-time">{m.time}</span>
              </div>
              <div className="email__row-subject">{m.subject}</div>
              {m.ai && <div className="email__row-ai">⚡ {m.ai}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

// ══════════════════════════════════════════════
// CARD 2 — AI-Powered CRM
// ══════════════════════════════════════════════
const CRMCard = () => (
  <div className="card__ui">
    <div className="crm__header">
      <div>
        <div className="crm__product">CILPRON CRM</div>
        <div className="crm__sub">Sales Pipeline · Q3 2025</div>
      </div>
      <span className="crm__ai-badge">⚡ AI Insights ON</span>
    </div>

    {/* KPI row */}
    <div className="crm__kpis">
      {[
        { label: "Open Deals",    val: "38",    color: "orange" },
        { label: "Won This Month",val: "$142k",  color: "green"  },
        { label: "Conversion",    val: "64%",   color: "teal"   },
        { label: "Avg Deal Age",  val: "12d",   color: "blue"   },
      ].map((k) => (
        <div key={k.label} className="crm__kpi">
          <div className={`crm__kpi-val crm__kpi-val--${k.color}`}>{k.val}</div>
          <div className="crm__kpi-label">{k.label}</div>
        </div>
      ))}
    </div>

    {/* Pipeline stages */}
    <div className="crm__pipeline-label">Pipeline</div>
    <div className="crm__pipeline">
      {[
        { stage: "Lead",      count: 14, pct: 100, color: "blue"   },
        { stage: "Qualified", count: 10, pct: 72,  color: "teal"   },
        { stage: "Proposal",  count: 8,  pct: 57,  color: "orange" },
        { stage: "Closing",   count: 6,  pct: 43,  color: "green"  },
      ].map((s) => (
        <div key={s.stage} className="crm__stage">
          <div className="crm__stage-meta">
            <span className="crm__stage-name">{s.stage}</span>
            <span className="crm__stage-count">{s.count}</span>
          </div>
          <div className="crm__bar-bg">
            <div
              className={`crm__bar-fill crm__bar-fill--${s.color}`}
              style={{ width: `${s.pct}%` }}
            />
          </div>
        </div>
      ))}
    </div>

    {/* AI suggestions */}
    <div className="crm__ai-box">
      <div className="crm__ai-title">⚡ AI Recommendations</div>
      <div className="crm__ai-items">
        <div className="crm__ai-item">Follow up with Acme Corp — 5 days idle</div>
        <div className="crm__ai-item">3 proposals expiring this week</div>
      </div>
    </div>
  </div>
);

// ══════════════════════════════════════════════
// CARD 3 — AI Hospitality Software
// ══════════════════════════════════════════════
const HospitalityCard = () => (
  <div className="card__ui">
    <div className="hosp__header">
      <div>
        <div className="hosp__product">CILPRON Hospitality</div>
        <div className="hosp__sub">Property Dashboard · Live</div>
      </div>
      <span className="hosp__live"><span className="hosp__live-dot" />Live</span>
    </div>

    {/* Date strip — bed icon + occupied, moon icon + available */}
    <div className="hosp__dates">
      {[
        { date: "19", label: "Today", occ: 75, avail: 60, active: true },
        { date: "20", label: "Sat",   occ: 78, avail: 61 },
        { date: "21", label: "Sun",   occ: 74, avail: 59 },
        { date: "22", label: "Mon",   occ: 69, avail: 55 },
      ].map((d) => (
        <div key={d.date} className={`hosp__date${d.active ? " hosp__date--active" : ""}`}>
          <div className="hosp__date-top">
            <span className="hosp__date-num">{d.date}</span>
            <span className="hosp__date-label">{d.label}</span>
          </div>
          <div className="hosp__date-icons">
            <div className="hosp__date-icon hosp__date-icon--bed">
              <span>🛏</span>
              <span>{d.occ}</span>
            </div>
            <div className="hosp__date-icon hosp__date-icon--moon">
              <span>🌙</span>
              <span>{d.avail}</span>
            </div>
          </div>
        </div>
      ))}
    </div>

    {/* Overview label */}
    <div className="hosp__overview-label">
      <span>📊 Overview</span>
      <span className="hosp__overview-feels">👍 Feels like</span>
    </div>

    {/* Reservation card */}
    <div className="hosp__res">
      <div className="hosp__guest">
        <div className="hosp__guest-avatar">KS</div>
        <div>
          <div className="hosp__guest-name">Kevin Sturgis</div>
          <div className="hosp__guest-contact">ksturgis@gmail.com · +234 801 234 5678</div>
        </div>
      </div>

      <div className="hosp__res-row">
        <div className="hosp__res-field">
          <div className="hosp__res-label">Arrival</div>
          <div className="hosp__res-val">Feb 22, 11:00 AM</div>
        </div>
        <div className="hosp__res-field">
          <div className="hosp__res-label">Departure</div>
          <div className="hosp__res-val">Feb 24, 11:00 AM</div>
        </div>
        <div className="hosp__res-field hosp__res-field--sm">
          <div className="hosp__res-label">Nights</div>
          <div className="hosp__res-val">2</div>
        </div>
        <div className="hosp__res-field">
          <div className="hosp__res-label">Room Type</div>
          <div className="hosp__res-val">Delux King</div>
        </div>
      </div>

      <div className="hosp__res-row">
        <div className="hosp__res-field hosp__res-field--sm">
          <div className="hosp__res-label">Room</div>
          <div className="hosp__res-val">202</div>
        </div>
        <div className="hosp__res-field hosp__res-field--sm">
          <div className="hosp__res-label">Adult</div>
          <div className="hosp__res-val">1</div>
        </div>
        <div className="hosp__res-field hosp__res-field--sm">
          <div className="hosp__res-label">Rate Code</div>
          <div className="hosp__res-val">AMP</div>
        </div>
        <div className="hosp__res-field hosp__res-field--sm">
          <div className="hosp__res-label">Discount</div>
          <div className="hosp__res-val">50</div>
        </div>
      </div>
    </div>

    {/* AI alert */}
    <div className="hosp__ai-alert">
      <div className="hosp__ai-icon">⚡</div>
      <div>
        <div className="hosp__ai-title">AI Revenue Insight</div>
        <div className="hosp__ai-body">Demand surge detected Friday–Sunday. Suggest raising rates 18% for 6 available rooms.</div>
      </div>
    </div>
  </div>
);
// ── Types ──────────────────────────────────────────────────────
interface Feature {
  id: number;
  icon: React.ReactNode;
  tag: string;
  title: string;
  desc: string;
  glows: string[];
  card: React.ReactNode;
}

// ── Feature data ───────────────────────────────────────────────
const FEATURES: Feature[] = [
  {
    id: 0,
    icon: <IconMail />,
    tag: "Business Email & Calendar",
    title: "Professional email and smart scheduling built for your team",
    desc: "CILPRON Mail gives your business a branded email experience with AI-assisted triage, priority labels, and a shared calendar — all in one workspace.",
    glows: ["orange", "gold"],
    card: <EmailCard />,
  },
  {
    id: 1,
    icon: <IconCRM />,
    tag: "AI-Powered CRM",
    title: "Close more deals with an AI that works your pipeline for you",
    desc: "Track leads, manage proposals, and get real-time AI recommendations on which deals to prioritise — so your sales team can focus on selling, not admin.",
    glows: ["teal", "blue"],
    card: <CRMCard />,
  },
  {
    id: 2,
    icon: <IconHotel />,
    tag: "Hospitality Software",
    title: "Run your property smarter with AI-driven management tools",
    desc: "From reservations and room status to revenue optimisation and guest communications — CILPRON Hospitality gives you one dashboard to manage it all.",
    glows: ["green", "purple"],
    card: <HospitalityCard />,
  },
];

// ── Main Component ─────────────────────────────────────────────
const ManagedAgents:React.FC = () => {
  const [activeIdx, setActiveIdx] = useState<number>(0);
  const groupRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const target = entry.target as HTMLElement;
          if (entry.isIntersecting) {
            setActiveIdx(parseInt(target.dataset.idx ?? "0", 10));
          }
        });
      },
      { threshold: 0.5 }
    );
    groupRefs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const scrollToGroup = (i: number) => {
    setActiveIdx(i);
    const el = groupRefs.current[i];
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <section className="ma">
      <div className="ma__eyebrow">
        <span className="ma__eyebrow-dot" />
        Digital Tools & Tech Solutions · CILPRON LTD · Est. 2024
      </div>

      <div className="ma__inner">
        {/* Sticky left nav */}
        <nav className="ma__text-col" aria-label="Products">
          {FEATURES.map((f, i) => (
            <div
              key={f.id}
              className={`ma__item${activeIdx === i ? " ma__item--active" : ""}`}
              onClick={() => scrollToGroup(i)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) =>
                (e.key === "Enter" || e.key === " ") && scrollToGroup(i)
              }
            >
              <span className="ma__item-icon" aria-hidden="true">{f.icon}</span>
              <span className="ma__item-tag">{f.tag}</span>
              <h3 className="ma__item-title">{f.title}</h3>
              <p className="ma__item-desc">{f.desc}</p>
            </div>
          ))}
        </nav>

        {/* Scrolling cards */}
        <div className="ma__cards">
          {FEATURES.map((f, i) => (
            <div
              key={f.id}
              className="ma__group"
              ref={(el: HTMLDivElement | null) => { groupRefs.current[i] = el; }}
              data-idx={i}
            >
              <div className="ma__card">
                {f.glows.map((g) => (
                  <span key={g} className={`ma__glow ma__glow--${g}`} />
                ))}
                {f.card}
              </div>

              {/* Mobile label */}
              <div className="ma__mobile">
                <div className="ma__mobile-row">
                  <span className="ma__mobile-icon">{f.icon}</span>
                  <h3 className="ma__mobile-title">{f.title}</h3>
                </div>
                <p className="ma__mobile-desc">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ManagedAgents;